import { combineReducers } from 'redux';
import userReducer from './slices/user';
import accountReducer from './slices/account';
import accountsThirdReducer from './slices/accountsThird';
import institutionsReducer from './slices/institutions';
import periodsReducer from './slices/periods';
import accountsByCompany from './slices/accountsByCompany';

const reducer = combineReducers({
    user: userReducer,
    account: accountReducer,
    accountsByCompany: accountsByCompany,
    accountThird: accountsThirdReducer,
    institutions: institutionsReducer,
    period: periodsReducer,
});

export default reducer;
